import { Component, Input, OnInit } from '@angular/core';
import { GeteventsService } from 'src/app/services/getevents.service';
import { GetenvironmentsService,  } from 'src/app/services/getenvironments.service';
import { GetfridgeService } from 'src/app/services/getfridge.service';


import { PubSub } from 'aws-amplify';

//Opciones select
const disp1: string = "Disp1";
const disp2: string = "Disp2";
const disp1view: string = "Cama";
const disp2view: string = "Sillón";

interface opcionSelect {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-tab-actual',
  templateUrl: './tab-actual.component.html', 
  styleUrls: ['./tab-actual.component.scss']
})

export class TabActualComponent implements OnInit { 

  DEBUG: boolean = true;

  //AWS
  pubSubMQTT;

  // IMPUTS
  @Input() arrayUser:any;

  timeini: number;
  timefin: number;
  time30min: number = 1800000; //30min en milisegundos

  arrayEnvironments_1: any;
  arrayEvens_1: any;
  arrayEnvironments_2: any;
  arrayEvens_2: any;
  arrayFridge: any;

  // opcionesDisp: opcionSelect[] = [
  //   { value: disp1,     viewValue: disp1view},
  //   { value: disp2,     viewValue: disp2view}
  // ];
  // selectOpcion = this.opcionesDisp[0].value;
  // selectedDisp = this.opcionesDisp[0].value;

  flagCarga: boolean = false;
  // DISPOSITIVO 1
  tempActual_1;
  humeActual_1;
  lumActual_1;
  ocupActual_1;
  flagOcupacionActual_1: boolean = false;
  flagDatos_1: boolean = false;
  ocupacionActualData_1;
  presenciaActualData_1;
  flagPresenciaActual_1: boolean = false;

  // DISPOSITIVO 2
  tempActual_2;
  humeActual_2;
  lumActual_2;
  ocupActual_2;
  flagOcupacionActual_2: boolean = false;
  flagDatos_2: boolean = false;
  ocupacionActualData_2;
  presenciaActualData_2;
  flagPresenciaActual_2: boolean = false;

  // DISPOSITIVO 3
  estadoActual_3;
  flagEstadoActual_3: boolean = false;
  flagDatos_3: boolean = false;
  estadoActualData_3;
  presenciaActualData_3;
  flagPresenciaActual_3: boolean = false;

  constructor(
    private getenvironmentsService: GetenvironmentsService,
    private geteventsService: GeteventsService,
    private getFridgeService: GetfridgeService,
  ) { }

  ngOnInit(): void {
    if(this.DEBUG){
    console.log("TAB ACTUAL: ");
    console.log (this.arrayUser);
      console.log("API - asyncMethodEnvironments:");
    }

    let topicDisp1: string = "PharaOn/updateAWS/"+this.arrayUser.disp1;
    let topicDisp2: string = "PharaOn/updateAWS/"+this.arrayUser.disp2;
    let topicDisp3: string = "PharaOn/updateAWS/"+this.arrayUser.disp3;

    // CARGAMOS LOS DATOS DEL LOS DISPOSITIVO
    // this.cargarDatosDispositivos();

    // actualizar ocupación en le momento
    if(this.DEBUG){
      console.log(topicDisp1);
      console.log(topicDisp2);
      console.log(topicDisp3);
    }
    this.pubSubMQTT  = PubSub.subscribe([topicDisp1, topicDisp2, topicDisp3], { provider: 'AWSIoTProvider' }).subscribe({
      next: dataMQTT => {
        this.mensajeRecibidoUpdateAWS(dataMQTT);
    },
      error: error => console.error(error)
    });

    this.actualizarDatosTiempoReal();

    this.asyncEnvioDatosMQTT(); 

    this.funcionCarga();
  }



  actualizar(){
    this.asyncEnvioDatosMQTT(); 
    this.funcionCarga();
  }
  
  async  asyncEnvioDatosMQTT() {
    if(this.DEBUG){
      console.log("Envio datos MQTT");
    }
      await PubSub.publish('PharaOn/esp32', { id: this.arrayUser.disp1, action: "SENDATA" }, { provider: 'AWSIoTProvider' });
      await PubSub.publish('PharaOn/esp32', { id: this.arrayUser.disp2, action: "SENDATA" }, { provider: 'AWSIoTProvider' });
      await PubSub.publish('PharaOn/esp32', { id: this.arrayUser.disp3, action: "SENDATA" }, { provider: 'AWSIoTProvider' });


  }

  mensajeRecibidoUpdateAWS(dataMQTT: any){
    if(this.DEBUG){
      console.log("mensajeRecibidoEvents");
    }
    let id = dataMQTT.value.id;
    let ocupacion;
    let pir;
    let temperatura;
    let humedad;
    let luminosidad;
    let frigo;

    // DISPOSIVIVO 1
    if(id == this.arrayUser.disp1){
      ocupacion = dataMQTT.value.sensor_data.ocup;
      pir = dataMQTT.value.sensor_data.pir;
      temperatura = dataMQTT.value.sensor_data.temp;
      humedad = dataMQTT.value.sensor_data.hume;
      luminosidad = dataMQTT.value.sensor_data.ilum;

      if(ocupacion == 1){
        this.ocupActual_1 = 'OCUPADO';
        this.flagOcupacionActual_1 = true;
      }else if (ocupacion == 0){
        this.ocupActual_1 = 'LIBRE';
        this.flagOcupacionActual_1 = false;
      }
      if(pir == 1){
        this.flagPresenciaActual_1 = true;
      }else if (pir == 0){
        this.flagPresenciaActual_1 = false;
      }
      this.tempActual_1 = temperatura;
      this.humeActual_1 = humedad;
      this.lumActual_1 = luminosidad;
      this.flagDatos_1 = true;
      
     // DISPOSIVIVO 2
    }else if(id == this.arrayUser.disp2){
      ocupacion = dataMQTT.value.sensor_data.ocup;
      pir = dataMQTT.value.sensor_data.pir;
      temperatura = dataMQTT.value.sensor_data.temp;
      humedad = dataMQTT.value.sensor_data.hume;
      luminosidad = dataMQTT.value.sensor_data.ilum;

      if(ocupacion == 1){
        this.ocupActual_2 = 'OCUPADO';
        this.flagOcupacionActual_2 = true;
      }else if (ocupacion == 0){
        this.ocupActual_2 = 'LIBRE';
        this.flagOcupacionActual_2 = false;
      }
      if(pir == 1){
        this.flagPresenciaActual_1 = true;
      }else if (pir == 0){
        this.flagPresenciaActual_1 = false;
      }
      this.tempActual_2 = temperatura;
      this.humeActual_2 = humedad;
      this.lumActual_2 = luminosidad;
      this.flagDatos_2 = true;

        // DISPOSIVIVO 3
      }else if(id == this.arrayUser.disp3){
        pir = dataMQTT.value.sensor_data.pir;
        frigo = dataMQTT.value.sensor_data.frigo;
      
        if(frigo == 1){
          this.estadoActual_3 = 'ABIERTO';
          this.flagEstadoActual_3 = true;
        }else if (frigo == 0){
          this.estadoActual_3 = 'CERRADO';
          this.flagEstadoActual_3 = false;
        }
        if(pir == 1){
          this.flagPresenciaActual_1 = true;
        }else if (pir == 0){
          this.flagPresenciaActual_1 = false;
        }
        this.flagDatos_3 = true;
        
      }

  }

  actualizarDatosTiempoReal(){
    let topicDispEvents1: string = "PharaOn/events/"+this.arrayUser.disp1;
    let topicDispEnvironments1: string = "PharaOn/environment/"+this.arrayUser.disp1;
    let topicDispEvents2: string = "PharaOn/events/"+this.arrayUser.disp2;
    let topicDispEnvironments2: string = "PharaOn/environment/"+this.arrayUser.disp2;
    let topicDispFridge3: string = "PharaOn/fridge/"+this.arrayUser.disp3;

    this.pubSubMQTT  = PubSub.subscribe([topicDispEvents1, topicDispEnvironments1,
                                          topicDispEvents2, topicDispEnvironments2,
                                          topicDispFridge3
                                        ], { provider: 'AWSIoTProvider' }).subscribe({
      next: dataMQTT => {
        this.mensajeRecibidoEvents(dataMQTT);
        if(this.DEBUG){
          console.log("mensajeRecibidoEvents" + dataMQTT)
        }
    },
      error: error => console.error(error)
    });

  }
  mensajeRecibidoEvents(dataMQTT: any){

    let id = dataMQTT.value.state.reported.id;
    let ocupacion = 3;
    let pir = 3;
    let frigo = 3;

        // DISPOSIVIVO 1
        if(id == this.arrayUser.disp1){
          ocupacion = dataMQTT.value.state.reported.cama1;
          pir = dataMQTT.value.state.reported.pir;


          if (dataMQTT.value.state.reported.temp != null && dataMQTT.value.state.reported.hume != null && dataMQTT.value.state.reported.ilum){
          this.tempActual_1 = dataMQTT.value.state.reported.temp;
          this.humeActual_1 = dataMQTT.value.state.reported.hume;
          this.lumActual_1 = dataMQTT.value.state.reported.ilum;
          }

          if(ocupacion == 1){
            this.ocupActual_1 = 'OCUPADO';
            this.flagOcupacionActual_1 = true;
          }else if (ocupacion == 0){
            this.ocupActual_1 = 'LIBRE';
            this.flagOcupacionActual_1 = false;
          }
          if(pir == 1){
            this.flagPresenciaActual_1 = true;
          }else if (pir == 0){
            this.flagPresenciaActual_1 = false;
          }

          this.flagDatos_1 = true;
          
         // DISPOSIVIVO 2
        }else if(id == this.arrayUser.disp2){
          ocupacion = dataMQTT.value.state.reported.cama1;
          pir = dataMQTT.value.state.reported.pir;

    
          if(ocupacion == 1){
            this.ocupActual_2 = 'OCUPADO';
            this.flagOcupacionActual_2 = true;
          }else if (ocupacion == 0){
            this.ocupActual_2 = 'LIBRE';
            this.flagOcupacionActual_2 = false;
          }
          if(pir == 1){
            this.flagPresenciaActual_2 = true;
          }else if (pir == 0){
            this.flagPresenciaActual_2 = false;
          }

          this.flagDatos_2 = true;
    
            // DISPOSIVIVO 3
          }else if(id == this.arrayUser.disp3){
            pir = dataMQTT.value.state.reported.pir;
            frigo = dataMQTT.value.state.reported.frigo;
          // console.log(frigo)
            if(frigo == 1){
              this.estadoActual_3 = 'ABIERTO';
              this.flagEstadoActual_3 = true;
            }else if (frigo == 0){
              this.estadoActual_3 = 'CERRADO';
              this.flagEstadoActual_3 = false;
            }
            if(pir == 1){
              this.flagPresenciaActual_3 = true;
            }else if (pir == 0){
              this.flagPresenciaActual_3 = false;
            }
            this.flagDatos_3 = true;
          }

  }

  funcionCarga(){

    setTimeout(() => {
      // this.bufferValue = 20;
      setTimeout(() => {
        // this.bufferValue = 40;
        setTimeout(() => {
          // this.bufferValue = 60;
          setTimeout(() => {
            // this.bufferValue = 80;
            setTimeout(() => {
              // this.bufferValue = 100;
              this.flagCarga = true;
              this.cargarDatosDispositivos();
              }, 200);
            }, 200);
          }, 200);
        }, 200);
    }, 200);

}


  // onOptionSelected() {
  //   if(this.DEBUG){
  //     console.log('[SELECTOR]  onOptionSelected: ' + this.selectOpcion);
  //   }
  //   switch(this.selectOpcion) { 
  //     case "Disp1": { 
  //         // CARGAMOS LOS DATOS DEL DISPOSITIVO-1
  //         if(this.DEBUG){
  //           console.log("API - asyncMethodEnvironments:");
  //         }
  //         this.asyncMethodEnvironments(this.arrayUser.disp1);
  //         if(this.DEBUG){
  //           console.log("API - asyncMethodEvents:");
  //         }
  //         this.asyncMethodEvents(this.arrayUser.disp1);
  //       break; 
  //    } 
  //     case "Disp2": { 
  //         // CARGAMOS LOS DATOS DEL DISPOSITIVO-2
  //         if(this.DEBUG){
  //           console.log("API - asyncMethodEnvironments:");
  //         }
  //         this.asyncMethodEnvironments(this.arrayUser.disp2);
  //         if(this.DEBUG){
  //           console.log("API - asyncMethodEvents:");
  //         }
  //         this.asyncMethodEvents(this.arrayUser.disp2);
  //        break; 
  //     } 
  //     default: { 
  //       //statements; 
  //       break; 
  //     } 
  //   }
  // }




  cargarDatosDispositivos(){
    if(this.DEBUG){
      console.log("API - asyncMethodEnvironments:");
    }
    this.asyncMethodEnvironments();
    if(this.DEBUG){
      console.log("API - asyncMethodEvents:");
    }
    this.asyncMethodEvents();
    if(this.DEBUG){
      console.log("API - asyncMethodFridge:");
    }
    this.asyncMethodFridge(); 
  }


  async asyncMethodEnvironments() {
    this.timeini = Date.now() - (this.time30min*4); // -1h;
    this.timefin = Date.now();

    if(this.DEBUG){
      console.log(this.timeini);
      console.log(this.timefin);
    }

//  OBTENEMOS LOS DATOS AMBIENTE DE LA CAMA SI CON MQTT NO HEMOS OBTENIDO RESPUESTA
    if(!this.flagDatos_1){

      this.arrayEnvironments_1 = await this.getenvironmentsService.getEnvironments(this.arrayUser.disp1, this.timeini, this.timefin);

      if(this.DEBUG){
        console.log("SERVICE ENVIRONMENTS CAMA: ");
        console.log (this.arrayEnvironments_1);
      }

      if(this.arrayEnvironments_1.length == 0){
        this.tempActual_1 = '-';
        this.humeActual_1 = '-';
        this.lumActual_1 = '-';
        this.flagDatos_1 = false;
        // alert("No hay datos ambientes del dispositivo seleccionado");
      }else{
        this.flagDatos_1 = true;
        this.tempActual_1 = this.arrayEnvironments_1[this.arrayEnvironments_1.length-1].temperatura;
        this.humeActual_1 = this.arrayEnvironments_1[this.arrayEnvironments_1.length-1].humedad;
        this.lumActual_1  = this.arrayEnvironments_1[this.arrayEnvironments_1.length-1].iluminacion;
      }
    }

    //  OBTENEMOS LOS DATOS AMBIENTE DEL SILLÓN SI CON MQTT NO HEMOS OBTENIDO RESPUESTA
    if(!this.flagDatos_2){

      this.arrayEnvironments_2 = await this.getenvironmentsService.getEnvironments(this.arrayUser.disp2, this.timeini, this.timefin);

      if(this.DEBUG){
        console.log("SERVICE ENVIRONMENTS SILLÓN: ");
        console.log (this.arrayEnvironments_2);
      }

      if(this.arrayEnvironments_2.length == 0){
        this.tempActual_2 = '-';
        this.humeActual_2 = '-';
        this.lumActual_2 = '-';
        this.flagDatos_2 = false;
        // alert("No hay datos ambientes del dispositivo seleccionado");
      }else{
        this.flagDatos_2 = true;
        this.tempActual_2 = this.arrayEnvironments_2[this.arrayEnvironments_2.length-1].temperatura;
        this.humeActual_2 = this.arrayEnvironments_2[this.arrayEnvironments_2.length-1].humedad;
        this.lumActual_2  = this.arrayEnvironments_2[this.arrayEnvironments_2.length-1].iluminacion;
      }
    }
  }

  async asyncMethodEvents() {
    this.timeini = Date.now() - (this.time30min*4);// -1h;
    this.timefin = Date.now();

    if(this.DEBUG){
      console.log(this.timeini);
      console.log(this.timefin);
    }

    //  OBTENEMOS LOS DATOS DE OCUPACIÓN DE LA CAMA SI CON MQTT NO HEMOS OBTENIDO RESPUESTA
    if(!this.flagDatos_1){
      this.arrayEvens_1 = await this.geteventsService.getEvents(this.arrayUser.disp1, this.timeini, this.timefin);

      if(this.DEBUG){
        console.log("SERVICE EVENTS CAMA: ");
        console.log (this.arrayEvens_1);
      }

      if(this.arrayEvens_1 == undefined || this.arrayEvens_1.length == 0){
      // if(this.arrayEvens_1.length == 0){
        this.ocupActual_1 = '-'; 
        this.flagDatos_1 = false;
        // alert("No hay datos del dispositivo seleccionado");
      }else{
        // this.flagDatos = true;
        for (let i = 0; i < this.arrayEvens_1.length; i++) {
          if(this.arrayEvens_1[i].cama1 != undefined){
            this.ocupacionActualData_1 = this.arrayEvens_1[i].cama1;
          }
          if(this.arrayEvens_1[i].pir != undefined){
            this.presenciaActualData_1 = this.arrayEvens_1[i].pir;
          }
        }
        if(this.ocupacionActualData_1 == 1){
          // this.ocupActual_1 = 'OCUPADO';
          this.flagOcupacionActual_1 = true;
        }else if (this.ocupacionActualData_1 == 0){
          // this.ocupActual_1 = 'LIBRE';
          this.flagOcupacionActual_1 = false;
        }
        if(this.presenciaActualData_1 == 1){
          // this.estadoActual_1 = 'PRESENCIA';
          this.flagPresenciaActual_1 = true;
        }else if (this.presenciaActualData_1 == 0){
          // this.estadoActual_1 = 'SIN PRESENCIA';
          this.flagPresenciaActual_1 = false;
            }
      }
    }
        //  OBTENEMOS LOS DATOS DE OCUPACIÓN DEL SILLÓN SI CON MQTT NO HEMOS OBTENIDO RESPUESTA
    if(!this.flagDatos_2){
      
      this.arrayEvens_2 = await this.geteventsService.getEvents(this.arrayUser.disp2, this.timeini, this.timefin);

      if(this.DEBUG){
        console.log("SERVICE EVENTS SILLÓN: ");
        console.log (this.arrayEvens_2);
      }
      
      if(this.arrayEvens_2 == undefined || this.arrayEvens_2.length == 0){
      // if(this.arrayEvens_2.length == 0){
        this.ocupActual_2 = '-'; 
        this.flagDatos_2 = false;
        // alert("No hay datos del dispositivo seleccionado");
      }else{
        // this.flagDatos = true;
        for (let i = 0; i < this.arrayEvens_2.length; i++) {
          if(this.arrayEvens_2[i].cama1 != undefined){
            this.ocupacionActualData_2 = this.arrayEvens_2[i].cama1;
          }
          if(this.arrayEvens_2[i].pir != undefined){
            this.presenciaActualData_2 = this.arrayEvens_2[i].pir;
          }
        }
        if(this.ocupacionActualData_2 == 1){
          // this.ocupActual_2 = 'OCUPADO';
          this.flagOcupacionActual_2 = true;
        }else if (this.ocupacionActualData_2 == 0){
          // this.ocupActual_2 = 'LIBRE';
          this.flagOcupacionActual_2 = false;
        }
        if(this.presenciaActualData_2 == 1){
          // this.estadoActual_2 = 'PRESENCIA';
          this.flagPresenciaActual_2 = true;
        }else if (this.presenciaActualData_2 == 0){
          // this.estadoActual_3 = 'SIN PRESENCIA';
          this.flagPresenciaActual_2 = false;
        }
      }
    }
  }

  async asyncMethodFridge() {

    this.timeini = Date.now() - (this.time30min*4);// -1h;
    this.timefin = Date.now();

    if(this.DEBUG){
      console.log(this.timeini);
      console.log(this.timefin);
    }

    if(!this.flagDatos_3){

      this.arrayFridge = await this.getFridgeService.getFridge(this.arrayUser.disp3, this.timeini, this.timefin);

      if(this.DEBUG){
        console.log("SERVICE FRIDGE: " + this.arrayFridge.length);
        console.log (this.arrayFridge);
      }
      if(this.arrayFridge == undefined || this.arrayFridge.length == 0){
      // if(this.arrayFridge.length == 0){
        this.estadoActual_3 = '-'; 
        this.flagDatos_3 = false;
        // alert("No hay datos del dispositivo seleccionado");
      }else{
        this.flagDatos_3 = true;
        for (let i = 0; i < this.arrayFridge.length; i++) {
          if(this.arrayFridge[i].frigo != undefined){
            this.estadoActualData_3 = this.arrayFridge[i].frigo;
          }
          if(this.arrayFridge[i].pir != undefined){
            this.presenciaActualData_3 = this.arrayFridge[i].pir;
          }
        }
        if(this.estadoActualData_3 == 1){
          this.estadoActual_3 = 'ABIERTO';
          this.flagEstadoActual_3 = true;
        }else if (this.estadoActualData_3 == 0){
          this.estadoActual_3 = 'CERRADO';
          this.flagEstadoActual_3 = false;
        }
        if(this.presenciaActualData_3 == 1){
          this.estadoActual_3 = 'PRESENCIA';
          this.flagPresenciaActual_3 = true;33
        }else if (this.presenciaActualData_3 == 0){
          this.estadoActual_3 = 'SIN PRESENCIA';
          this.flagPresenciaActual_3 = false;
        }
      }
    }
  }


}
